import React from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import { isDesktop } from '../../../../utils/mobileHelpers';
import { VisitConsents } from '../VisitConsents';
import Popup from '../../../common/Popup';
import Paper from '../../../Paper';

function CompletedConsentPopup({
  item,
  opened,
  onClose,
  targetUser,
  formatMessage,
}) {
  const userAppointmentService = get(item, 'userAppointment.service');
  const dateTime = get(item, 'userAppointment.startTime');

  const consentItem = {
    service: userAppointmentService,
    dateTime,
    consentsAssignment: item,
    patientUserInfo: targetUser,
  };

  return (
    <Popup
      strictClose
      opened={opened}
      onClose={onClose}
      title={formatMessage({ id: 'appointments.form.consentForm' })}
      width={isDesktop() ? 'small' : 'medium'}
    >
      <Paper isLayoutColumn className="pa3">
        <VisitConsents
          appointment={consentItem}
          formatMessage={formatMessage}
        />
      </Paper>
    </Popup>
  );
}

CompletedConsentPopup.propTypes = {
  formatMessage: PropTypes.func,
  opened: PropTypes.bool,
  item: PropTypes.object,
  onClose: PropTypes.func,
  targetUser: PropTypes.object,
};

export default CompletedConsentPopup;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/CompletedConsentPopup/index.jsx